import React from 'react';
import { BaseMessage, ForceIntoVisibilityClassName } from '@bingads-webui/ads-copilot-ui';
import { makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';

function createKeyframes(name: string, rules: string) {
  const styleSheet = document.styleSheets[0] as CSSStyleSheet;
  styleSheet.insertRule(`@keyframes ${name} { ${rules} }`, styleSheet.cssRules.length);
  return name;
}

const dots = createKeyframes('dots', `
  0% { opacity: 0.3; }
  50% { opacity: 1; }
  100% { opacity: 0.3; }
`);


const useTypingIndicatorStyles = makeStyles({
  typingIndicatorRoot: {
    width: 'fit-content',
    marginTop: tokens.spacingVerticalM,
    marginLeft: tokens.spacingHorizontalXS,
    marginBottom: tokens.spacingVerticalXS,
  },
  typingIndicator: {
    boxSizing: 'content-box',
    fontSize: 'inherit',
    fontFamily: 'Helvetica Neue, Segoe UI, Helvetica, Arial, sans-serif',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    height: '6px',
  },
  indicator: {
    boxSizing: 'inherit',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  dotBase: {
    boxSizing: 'inherit',
    display: 'inline-block',
    height: '6px',
    width: '6px',
    backgroundColor: '#B3B3B3',
    marginRight: '3px',
    animationName: dots,
    animationDuration: '1.5s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
    ...shorthands.borderRadius('100%'),
  },
  secondTypingDot: {
    marginRight: '3px',
    animationDelay: '0.25s',
  },
  thirdTypingDot: {
    animationDelay: '0.5s',
  },
});

export const TypingIndicator = () => {
  const styles = useTypingIndicatorStyles();
  return (
    <BaseMessage className={mergeClasses('typing-indicator', ForceIntoVisibilityClassName, styles.typingIndicatorRoot)}>
      <div className={styles.typingIndicator}>
        <div className={styles.indicator}>
          <div className={mergeClasses('first-typing-dot', styles.dotBase)} />
          <div className={mergeClasses('second-typing-dot', styles.dotBase, styles.secondTypingDot)} />
          <div className={mergeClasses('third-typing-dot', styles.dotBase, styles.thirdTypingDot)} />
        </div>
      </div>
    </BaseMessage>
  );
};
